(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["arclab-size-popuplink"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('arc-size-guide')) {
    customElements.define('arc-size-guide', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        const trigger = this.querySelector('[data-arc-open]');
        const dialog = this.querySelector('dialog');
        if (!trigger || !dialog || typeof dialog.showModal !== 'function') return;
        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.setAttribute('aria-controls', dialog.id);
        this.querySelectorAll('.arc-guide__content table').forEach((table) => {
          if (table.parentElement.classList.contains('arc-guide__table-wrap')) return;
          const wrapper = document.createElement('div');
          wrapper.className = 'arc-guide__table-wrap';
          wrapper.tabIndex = 0;
          wrapper.setAttribute('role', 'region');
          wrapper.setAttribute('aria-labelledby', dialog.getAttribute('aria-labelledby'));
          table.before(wrapper);
          wrapper.append(table);
        });
        trigger.addEventListener('click', (event) => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          dialog.showModal();
        }, { signal });
        this.querySelectorAll('[data-arc-close]').forEach((button) => {
          button.addEventListener('click', () => dialog.close(), { signal });
        });
        dialog.addEventListener('keydown', (event) => {
          if (event.key !== 'Tab') return;
          const items = [...dialog.querySelectorAll('a[href], button, input, select, textarea, summary, [tabindex]')]
            .filter((item) => item.tabIndex >= 0 && !item.disabled && item.getClientRects().length > 0);
          const first = items[0];
          const last = items[items.length - 1];
          if (!first) { event.preventDefault(); return; }
          if (event.shiftKey && (document.activeElement === first || !items.includes(document.activeElement))) {
            event.preventDefault(); last.focus();
          } else if (!event.shiftKey && (document.activeElement === last || !items.includes(document.activeElement))) {
            event.preventDefault(); first.focus();
          }
        }, { signal });
        const outside = (event) => {
          const rect = dialog.getBoundingClientRect();
          return event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom);
        };
        let startedOutside = false;
        dialog.addEventListener('pointerdown', (event) => { startedOutside = outside(event); }, { signal });
        dialog.addEventListener('click', (event) => { if (startedOutside && outside(event)) dialog.close(); startedOutside = false; }, { signal });
        dialog.addEventListener('close', () => { if (trigger.isConnected) trigger.focus({ preventScroll: true }); }, { signal });
      }
      disconnectedCallback() {
        this.querySelector('dialog[open]')?.close();
        this.controller?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
